module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAQAAACqy3WpAAAAsElEQVR4AbXUvQ2DQBAF4SUxGTHxSLgGeqAIisCuwhRBEfSAaIEGiMlsAmwy/3J3q8Wa/JMQt0+42/oD0CKOWh8wc3QCGbMbqBFPtQsYSbxAwrgNlEhA5RbQEwUBEf0vYCFHAstZvoEGUdR8AhOpCkiZ3oETouz8CgzEaiBmeAIFgr5iR2DgYPqEtUoNVDv/RvNDsj/ltS74mDrjOZsHxTZpF/cm3sg8o3rdf9ZtmYEHJxf9kx/FQEoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/hexagon-bullet.png
// module id = 1707
// module chunks = 0